import styled from 'styled-components'

export default styled.div`
	position: relative;
	
  * {
    vertical-align: middle;
    line-height: 14px;
  }
`